export const EventDatesMixin = {

    methods: {
        fixEventsData() {
            this.events?.forEach(this.fixEventData);

            this.eventTemplates?.forEach(this.fixEventData);
        },

        fixEventData(event) {
            if (!event._start_time) {
                event._start_time = moment(event.start_time);
                event._end_time = moment(event.end_time);
                event._start_hour = event._start_time.hour();
                event._start_minute = event._start_time.minute();
                event._start_on_minute = event._start_hour * 60 + event._start_minute;
                event._end_hour = event._end_time.hour();
                event._end_minute = event._end_time.minute();
                event._end_on_minute = event._end_hour * 60 + event._end_minute;
                event._duration_in_minutes = (event._end_hour * 60 + event._end_minute) - (event._start_hour * 60 + event._start_minute);
                event._duration_in_hours = event._duration_in_minutes / 60;
                event._iso_weekday = event._start_time.isoWeekday();

                event._offset = event._start_hour + event._start_minute / 60;
            }

            if (!event._recurrence && event.is_recurring) {

                if (!event.recurring_pattern) {

                    event.is_recurring = false;
                    // event._recurrence = moment.recur();

                } else {
                    switch (event.recurring_pattern.recurring_type_id) {
                        case 'weekly':
                            event._recurrence = moment.recur(event.start_date, event.end_date)
                                .every(event.recurring_pattern.days_of_week
                                    .map((day) => day - 1) /* Convert from ISO day */
                                ).daysOfWeek();

                            if (event.cancelled_instances) {
                                event.cancelled_instances.forEach((event_exception) => {
                                    event._recurrence.except(event_exception.start_date);
                                });
                            }

                            break;
                        default:
                            console.log('Invalid recurring interval');
                    }
                }
            }
        },
    },
};
